module.exports = __webpack_public_path__ + "img/9F1A27_F1AF7F_CD5845_D08441-256px.8bb386b9.png";